export const EVENTS = {
	authStore: {
		logout: 'authStore/logout',
	},
	notifyStore: {
		fireError: 'notifyStore/fireError',
	},
	careStore: {
		updateHeader: 'careStore/updateHeader',
	},
	homeStore: {
		updateActivationOverall: 'homeStore/updateActivationOverall',
	},
}

export const ACTIONS = {
	appStore: {
		init: 'appStore/init',
	},

	authStore: {
		changeToken: 'authStore/changeToken',
	},

	careStore: {
		fetchWorkerDetail: 'careStore/fetchWorkerDetail',
	},

	careActivationStore: {
		fetchOnboardingOverview: 'careActivationStore/fetchOnboardingOverview',
	},

	careProfileStore: {
		handleSubmitInfo: 'careProfileStore/handleSubmitInfo',
		handleSubmitExperiences: 'careProfileStore/handleSubmitExperiences',
		handleSubmitLicenses: 'careProfileStore/handleSubmitLicenses',
		fetchWorkerDetail: 'careProfileStore/fetchWorkerDetail',
	},

	careTimeCardsStore: {
		fetchTimeCards: 'careTimeCardsStore/fetchTimeCards',
	},

	licenseStepStore: {
		handleSubmitLicense: 'licenseStepStore/handleSubmitLicense',
	},

	experienceStepStore: {
		handleSubmitExperiences: 'experienceStepStore/handleSubmitExperiences',
	},

	referenceStepStore: {
		handleSubmitReferences: 'referenceStepStore/handleSubmitReferences',
	},

	profileCompletionStore: {
		fetchUserForm: 'profileCompletionStore/fetchUserForm',
	},
}
